<template>
  <div>
    <slot name="ariaTitle"></slot>

    <div class="c-analysts-chart">
      <span class="sr-only" v-if="isAccessibilityEnabled">{{ screenReaderText }}</span>
      <div :class="'c-analysts-chart__buy'">
        <span class="sr-only" v-if="buy && isAccessibilityEnabled">{{ i18n('strong-buy') }}</span
        >{{ isNaN(buy) ? '' : buy }}
      </div>
      <div :class="'c-analysts-chart__outperform'">
        <span class="sr-only" v-if="outperform && isAccessibilityEnabled">{{ i18n('buy') }}</span
        >{{ isNaN(outperform) ? '' : outperform }}
      </div>
      <div :class="'c-analysts-chart__hold'">
        <span class="sr-only" v-if="hold && isAccessibilityEnabled">{{ i18n('hold') }}</span
        >{{ isNaN(hold) ? '' : hold }}
      </div>
      <div :class="'c-analysts-chart__underperform'">
        <span class="sr-only" v-if="underperform && isAccessibilityEnabled">{{ i18n('sell') }}</span
        >{{ isNaN(underperform) ? '' : underperform }}
      </div>
      <div :class="'c-analysts-chart__sell'">
        <span class="sr-only" v-if="sell && isAccessibilityEnabled">{{ i18n('strong-sell') }}</span
        >{{ isNaN(sell) ? '' : sell }}
      </div>
      <span class="c-analysts-chart__recommendation" :style="style" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'c-analysts-chart',
  props: {
    mean: {
      type: Number
    },
    buy: {
      type: Number
    },
    outperform: {
      type: Number
    },
    hold: {
      type: Number
    },
    underperform: {
      type: Number
    },
    sell: {
      type: Number
    }
  },
  computed: {
    style() {
      if (isNaN(this.mean)) return { display: 'none' };
      let left;
      if (this.mean < 1.5) {
        left = 0; // start of 'buy' square
        left += (this.mean * 100) / 1.5 / 5; // add mean value
      }
      if (this.mean >= 1.5 && this.mean < 2.5) {
        left = 20; // start of 'buy' square
        left += ((this.mean - 1.5) * 100) / 5; // add mean value
      }
      if (this.mean >= 2.5 && this.mean < 3.5) {
        left = 40; // start of 'buy' square
        left += ((this.mean - 2.5) * 100) / 5; // add mean value
      }
      if (this.mean >= 3.5 && this.mean < 4.5) {
        left = 60; // start of 'buy' square
        left += ((this.mean - 3.5) * 100) / 5; // add mean value
      }
      if (this.mean >= 4.5) {
        left = 80; // start of 'buy' square
        left += ((this.mean - 4.5) * 100) / 5; // add mean value
        if (left > 100) left = 100;
      }
      return {
        left: `${left}%`
      };
    },
    screenReaderText() {
      if (this.mean < 1.5) return `${this.i18n('strong-buy')} ${this.mean}`;
      if (this.mean >= 1.5 && this.mean < 2.5) return `${this.i18n('buy')} ${this.mean}`;
      if (this.mean >= 2.5 && this.mean < 3.5) return `${this.i18n('hold')} ${this.mean}`;
      if (this.mean >= 3.5 && this.mean < 4.5) return `${this.i18n('sell')} ${this.mean}`;
      if (this.mean >= 4.5) return `${this.i18n('strong-sell')} ${this.mean}`;
    },
    isAccessibilityEnabled() {
      return this.$store.state.applicationSettings.accessibility.settings.accessibilityFeatures;
    }
  },
  methods: {
    i18n(subkey) {
      return this.$t(`white-label.${'widgets.analystEvaluation.labels'}.${subkey}`);
    }
  }
};
</script>

<style lang="scss">
@import '~@/styles/components/custom/c-analysts-chart';
</style>
